/**
 * ============================================================================
 * ⚪ Shared Photo Carousel Pager Dots
 * ============================================================================
 */

/**
 * Renders a row of clickable pager dots into `container` for a photo
 * carousel. Shared by the Inspector's hero photo and the Lightbox modal so
 * both carousels stay visually and behaviorally in sync.
 *
 * @param {HTMLElement|null} container
 * @param {number} count - total number of photos
 * @param {number} currentIndex
 * @param {(index: number) => void} onSelect - called with the clicked dot's index
 */
export function renderPhotoDots(container, count, currentIndex, onSelect) {
  if (!container) return;

  if (count <= 1) {
    container.innerHTML = '';
    return;
  }

  container.innerHTML = Array.from({ length: count }, (_, i) => `
    <span class="p-dot ${i === currentIndex ? 'active' : ''}" data-idx="${i}">
      ${i === currentIndex ? '●' : '○'}
    </span>
  `).join('');

  container.querySelectorAll('.p-dot').forEach((dot) => {
    dot.addEventListener('click', (e) => {
      e.stopPropagation();
      onSelect(parseInt(dot.dataset.idx, 10));
    });
  });
}
